<form *ngIf="accountCategories.length" class="container" [formGroup]="editForm">
  <div class="account-edit-form">
    <h6>Account id: {{ accountDetails.id }}</h6>
    <br />
    <label>Display Name</label>
    <input type="text" class="form-control" formControlName="displayName" />
    <br />
    <label>Category</label>
    <select class="form-control" formControlName="category">
      <option
        *ngFor="let category of accountCategories"
        [value]="category.code"
      >
        {{ category.displayName }}
      </option>
    </select>
    <br />
    <label>Description</label>
    <textarea
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      class="form-control"
      formControlName="description"
    ></textarea>
    <div
      *ngIf="
        accountDescription.invalid &&
        (accountDescription.dirty || accountDescription.touched)
      "
      class="form-control-feedback text-danger"
    >
      <small *ngIf="accountDescription.hasError('maxlength')">
        Account description must not exceed 1000 characters
      </small>
    </div>
    <br />
    <label>Expiration date</label>
    <div class="form-control expiration-date-picker">
      <input
        formControlName="expirationDate"
        ngbDatepicker
        #d="ngbDatepicker"
        placeholder="dd/mm/yyyy"
      />
      <i class="fas fa-calendar" (click)="d.toggle()"></i>
    </div>
    <div
      *ngIf="
        expirationDate.invalid &&
        (expirationDate.dirty || expirationDate.touched)
      "
      class="form-control-feedback text-danger"
    >
      <small
        *ngIf="
          expirationDate.hasError('ngbDate') ||
          expirationDate.hasError('wrongDate')
        "
        >Must not be in the past</small
      >
    </div>
    <ng-container *ngIf="hasSubscriptionId">
      <br />
      <label>Subscription Id</label>
      <input
        type="text"
        class="form-control"
        maxLength="17"
        formControlName="subscriptionId"
      />
      <div
        *ngIf="
          subscriptionId.invalid &&
          (subscriptionId.dirty || subscriptionId.touched)
        "
        class="form-control-feedback text-danger"
      >
        <small *ngIf="subscriptionId.hasError('required')">
          Subscription ID is required for non-Trial accounts
        </small>
        <small *ngIf="subscriptionId.hasError('pattern')">
          Subscription Id is invalid. It should have 16 alphanumeric characters
        </small>
      </div>
      <br />
    </ng-container>
  </div>
  <div class="buttons">
    <button class="btn btn-link" (click)="cancelSubmit.emit()">
      <i class="fas fa-pencil-alt"></i> Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      [disabled]="editForm.pristine || !editForm.valid"
      (click)="onSubmit()"
    >
      <i class="far fa-edit"></i> Update
    </button>
  </div>
</form>
<div class="spinner-container" *ngIf="progress">
  <app-loading-spinner></app-loading-spinner>
</div>
